.root {
  display: grid;
  grid-template-columns: 2fr auto auto;
  gap: var(--spacingMd);
}
